import { TYPENAMES } from '@spotify/confidence-graphql';

export type RecentActivityResourceConfig = {
  route: string;
  typename?: string;
};

export const RECENT_ACTIVITY_TYPENAMES = {
  flags: TYPENAMES.Flag,
  segments: TYPENAMES.Segment,
  materializedSegments: TYPENAMES.MaterializedSegment,
  metrics: TYPENAMES.Metric,
  measurements: TYPENAMES.Measurement,
  eventDefinitions: TYPENAMES.EventDefinition,
  surfaces: TYPENAMES.Surface,
  projects: TYPENAMES.Project,
  initiatives: TYPENAMES.Initiative,
  collections: TYPENAMES.Collection,
  assignmentTables: TYPENAMES.AssignmentTable,
  factTables: TYPENAMES.FactTable,
  entities: TYPENAMES.Entity,
  workflows: TYPENAMES.WorkflowInstance,
  issues: TYPENAMES.Issue,
  chats: TYPENAMES.Chat,
  pulses: TYPENAMES.Pulse,
} as const;

const resourceConfigs = new Map<string, RecentActivityResourceConfig>();

export const registerRecentActivityResources = (
  configs: Record<string, RecentActivityResourceConfig>,
) => {
  for (const [collection, config] of Object.entries(configs)) {
    resourceConfigs.set(collection, config);
  }
};

export const getResourceRoute = (collection: string): string | undefined =>
  resourceConfigs.get(collection)?.route;

export const getResourceTypename = (collection: string): string | undefined =>
  resourceConfigs.get(collection)?.typename;
